/**
 * Prediction Storage Utilities
 */

/**
 * Get tomorrow's date in YYYY-MM-DD format (UTC)
 */
export function getTomorrowDate(): string {
  const tomorrow = new Date();
  tomorrow.setUTCDate(tomorrow.getUTCDate() + 1);
  return tomorrow.toISOString().split('T')[0];
}

/**
 * Validate Ethereum address format
 */
export function isValidEthAddress(address: string): boolean {
  return /^0x[a-fA-F0-9]{40}$/.test(address);
}
